module.exports = __webpack_public_path__ + "assets/img/branch-icon-active-grey.c45ef3fd.svg";